import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Cart from '@/components/cart/cart'
import ModalAddress from '@/components/modalAddressHome/modalAddress'
import ModalProgram from '@/components/modalAsideProgram/modalAsideProgram'

@Component({
  components: {
    Cart,
    ModalAddress,
    ModalProgram
  }
})
export default class AddressProgram extends Vue {

  @Getter getIsToken: any
  @Getter getUser
  @Getter getCurrentProgram
  @Getter getCurrentAddress

  @Mutation PATH_TEMPORAL
  @Mutation OPEN_CART


  // Address Modal
  showAddressModal = false
  selectedAddress = {}

  // Program Modal
  showProgramModal = false


  async mounted() {
    if (this.$route.params.modal == 'program') {
      this._toggleProgramModal()
    }
    if (this.$route.params.modal == 'address') {
      this._toggleAddressModal()
    }
  }

  @Watch('getUser')
  setAddress() {
    this.selectedAddress = this.getUser.addresses[0]
  }

  /* Modal edit - add address */
  _toggleAddressModal() {
    if (this.getIsToken) {
      // this.showAddressModal = !this.showAddressModal
      this.$root.$emit('address-modal');
    } else {
      this._redirectToLogin('address')
    }
  }

  /* Modal program */
  _toggleProgramModal() {
    if (this.getIsToken) {
      // this.showProgramModal = !this.showProgramModal
      this.$root.$emit('program-modal');
    } else {
      this._redirectToLogin('program')
    }
  }

  _redirectToLogin(option: string) {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    params["modal"] = option

    this.PATH_TEMPORAL({ name, params, query })
    window.location.href = '/login'
  }
}
